import { computed } from 'vue';
import { useStorage } from '@vueuse/core';
import { useRoute } from 'vue-router';
import {
  useLocalPreferencesStore,
  userScopedKey
} from '@/stores/localPreferences';
import { LocalPreferenceKeys } from '@/types/enums/LocalPreferenceKeys';

// Whether the group-quorum controls (GroupQuorumControl) are shown on the
// participants step. Off by default; the choice is persisted the same way as
// `useExpertSettings` — device-local per signed-in user, session-scoped on the
// anonymous public create route.
export function useQuorumControlSetting() {
  const route = useRoute();
  const localPreferencesStore = useLocalPreferencesStore();

  const sessionQuorumControl = useStorage(
    userScopedKey(LocalPreferenceKeys.QUORUM_CONTROL),
    false,
    sessionStorage,
    { initOnMounted: true }
  );

  const isPublicCreateRoute = computed(
    () => route.name === 'p-document-create'
  );

  const quorumControl = computed(() =>
    isPublicCreateRoute.value
      ? sessionQuorumControl.value
      : localPreferencesStore.quorumControl
  );

  function toggleQuorumControl() {
    if (isPublicCreateRoute.value) {
      sessionQuorumControl.value = !sessionQuorumControl.value;
      return;
    }
    localPreferencesStore.quorumControl = !localPreferencesStore.quorumControl;
  }

  return {
    quorumControl,
    toggleQuorumControl
  };
}
